<div class="not-logged-page">
  <div class="content">
    <div class="icon-header"><fa-icon [icon]="faTriangleExclamation"></fa-icon></div>
    <div class="title-container"><h1>You don't have permission to access the application</h1></div>
   
    <div class="subtitle-container"> <div>Please contact your supervisor to request access</div></div>
    <!-- <button (click)="navigateToLogin()">Go to Login Page</button> -->
  </div>

</div>
